<template>
    <div
        class="flex items-center justify-between gap-4 bg-neutral p-4 text-xs lg:justify-start xl:text-sm xl:screen-ratio-[2:1]:py-2 xl:screen-ratio-[2:1]:text-xs"
    >
        <slot />
    </div>
</template>